module.exports = __webpack_public_path__ + "assets/media/day10.57b6816f.mp3";